import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

const StyledNewTag = styled.div`
  width: 30px;
  border-radius: 12px;
  padding: 2px 6px;
  font-size: 9px;
  font-weight: 500;
  line-height: 13px;
  text-align: center;
  color: #ffffff;
  background: linear-gradient(81.82deg, #e96140 7.54%, #f655bb 95.65%);
`

const NewTag = () => {
  const { t } = useTranslation()

  return <StyledNewTag>{t('new')}</StyledNewTag>
}

export default NewTag
